export default class Filter {
  /**
  * Constructs a new filter instance.
  * @param {object} options - Options.
  */
  constructor (options) {
    this.element = options.element
    this.filterSection = this.element.queryAll('.prdctfltr_filter');

    this.filterSection.forEach((element) => {
      const filterSectionTitle = element.querySelector('.prdctfltr_regular_title')
      filterSectionTitle.addEventListener('click', (element) => {
        filterSectionTitle.classList.toggle('active')
        filterSectionTitle.nextElementSibling.classList.toggle('expanded')
      })
    })
  }
}



// WEBPACK FOOTER //
// ./components/woocommerce/shop/product-filter/index.js